import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/Post-Sales-Connect-min.png"

const Postsalesconnect = () => {
  return (
    <>
     <div className="home-container">
      <Sidebar/>
      <div className="home-content">
        <img
             src={image}
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
    </>
  )
}

export default Postsalesconnect